import uniq from "lodash/uniq";

import { QueryKeys, useEntities } from "@/api/core";
import { useLoggedIn } from "@/hooks";
import { relationshipSchema } from "@/schemas";

function useAccountRelationships(ids: string[]) {
  const { isLoggedIn } = useLoggedIn();
  const sortedIds = uniq(ids.sort());

  const { data: relationships, ...result } = useEntities({
    queryKey: QueryKeys.relationships.list(sortedIds),
    endpoint: "/api/v1/accounts/relationships",
    schema: relationshipSchema,
    params: {
      id: sortedIds,
    },
    keepPreviousData: true,
    enabled: isLoggedIn && sortedIds.length > 0,
  });

  return {
    ...result,
    relationships: relationships || [],
  };
}

export { useAccountRelationships };
